export const order = "/order";

export const getSalesDashboardOrdersCounter = `${order}/getSalesDashboardOrdersCounter`;

export const getAllVendorCounters = `${order}/getAllVendorCounters`;

export const getAppStockOrdersCount = `${order}/getAppStockOrdersCount`;

export const assignCourierToOrderItem = `${order}/assignCourierToOrderItem`;

export const getRepriceNeededOrders = `${order}/getPendingRepricingDashboardDetails`;

export const toggleRepriceNeededOrder = `${order}/:orderId/toggleOrderIsRepricingNeeded`;

export const getSalesDashboardOrders = `${order}/getSalesDashboardOrders`;

export const getNeedSupportDashboardDetails = `${order}/getNeedSupportDashboardDetails`;

export const getNeedSupportDoneOrdersDetails = `${order}/getNeedSupportDoneOrdersDetails`;

export const getVendorSupportReturnsDetails = `${order}/getVendorSupportReturnOrdersDashboardDetails`;

export const markReturnOrderAsNoActionNeeded = `${order}/markReturnOrderIsActionNeededFalse/:returnOrderId`;

export const getAllOrdersPendingApproval = `${order}/getAllOrdersPendingApproval`;

export const cancelOrder = `${order}/cancelOrder`;

export const createOrder = `${order}/createOrder`;

export const UPDATE_ORDER_ITEM_QUANTITY = `${order}/updateOrderItemQuantity`;

export const getOrderDetails = `${order}/:orderId/getOrderDetails`;

export const addOrderItems = `${order}/createOrderItemList`;

export const REALLOCATE_ORDER_ITEM_SUPPLIER = `${order}/reallocateOrderItemSupplier`;

export const getFollowUpOrderDetails = `${order}/:orderId/getFollowUpOrderDetails`;

export const getMechanicNeedSupportOrderItems = `${order}/getMechanicNeedSupportOrderItems`;

export const getMechanicNeedSupportDoneOrderItems = `${order}/getMechanicNeedSupportDoneOrderItems`;

export const markMechanicSupportNeededFalse = `${order}/markMechanicSupportNeededFalse`;

export const addMechanicNeedSupportDetails = `${order}/addMechanicNeedSupportDetails`;

export const getAllVoiceOrders = `${order}/getAllVoiceOrders`;

export const getAllVoiceNotes = `${order}/getAllVoiceNotes`;

export const getVoiceNoteModesWithCounters = `${order}/getVoiceNoteModesWithCounters`;

export const getVoiceAppOrdersInQueue = `${order}/getVoiceAppOrdersInQueue`;

export const getAllApprovedOrders = `${order}/getAllApprovedOrders`;

export const getSalesDashboardSummary = `${order}/salesDashboard/summary`;

export const updateOrderRepComment = `${order}/updateRepCommentGivenOrderId`;

export const deleteOrderItem = `deleteOrderItem`;

export const deleteBundleItems = `${order}/:orderId/deleteBundleItems/:bundleId`;

export const checkOrderTasksForCourier = `${order}/checkOrderTasksForCourier`;

export const getVendorSupportOrderCountForAreas = `${order}/getVendorSupportOrderCountForAreas`;

export const getVendorSupportPendingPricingOrders = `${order}/getVendorSupportPendingPricingOrders`;

export const getVendorSupportPricingDoneOrders = `${order}/getVendorSupportPricingDoneOrders`;

export const getOrderPricingHistory = `${order}/getOrderPricingHistory`;

export const createOrderPricing = `${order}/createOrderPricing`;

export const getSalesDashboardOrdersPendingCommunication = `${order}/getSalesDashboardOrdersPendingCommunication`;

export const getSalesDashboardOrdersCommunicated = `${order}/getSalesDashboardOrdersCommunicated`;

export const getVoiceAppOrdersPendingPricingCommunication = `${order}/getVoiceAppOrdersPendingPricingCommunication`;

export const getVoiceAppOrdersDonePricingCommunication = `${order}/getVoiceAppOrdersDonePricingCommunication`;

export const getVoiceAppOrdersModesWithCounters = `${order}/getVoiceAppOrdersModesWithCounters`;

export const markIsPriceCommunicatedAsTrue = `${order}/markIsPriceCommunicatedAsTrue`;

export const getNotYetCommunicatedToSuppliersOrders = `${order}/getNotYetCommunicatedToSuppliersOrders`;

export const getSuccessfullyCommunicatedToSuppliersOrders = `${order}/getSuccessfullyCommunicatedToSuppliersOrders`;

export const updateIsOrderPreparationCommunicatedAsDone = `${order}/updateIsOrderPreparationCommunicatedAsDone`;

export const getMechanicAppPricedItems = `${order}/getMechanicAppPricedItems`;

export const calculateActualDeliveryFullDate = `${order}/calculateActualDeliveryFullDate`;

export const createVoiceOrderFromMechanicComplaint = `${order}/createVoiceOrderFromMechanicComplaint`;

export const returnBundle = `${order}/returnBundleQuantity`;

export const addOrderItemImages = `addOrderItemImages`;

export const deleteOrderItemImage = `${order}/deleteOrderItemImage`;

export const editDeliveryDate = `${order}/editDeliveryDate`;

export const getAllOrdersForAssignCouriers = `${order}/getAllOrdersForAssignCouriers`;

export const acceptOrder = `${order}/acceptOrder`;

export const getOrderInvoiceInfo = `${order}/:orderId/getOrderInvoiceInfo`;

export const CANCEL_RETURN_ORDER = `${order}/cancelReturnOrder/:returnOrderId`;

export const getOrderRoute = `${order}/getOrderRoute`;

export const REVOKE_ORDER_ITEM_COURIER_ASSIGNMENT = `${order}/revokeOrderItemCourierAssignment/:orderItemId`;

export const REVOKE_RETURN_ORDER_COURIER_ASSIGNMENT = `${order}/revokeReturnOrderCourierAssignment/:returnOrderId`;

export const updateOrderItemReturnQuantityV2 = `${order}/updateOrderItemReturnQuantityV2`;

export const revokeBundleCourierAssignment = `${order}/:orderId/revokeBundleCourierAssignment/:bundleId`;

export const assignCourierToBundle = `${order}/assignCourierToBundle`;

export const getOrderProfile = `${order}/getOrderProfile`;

export const assignCourierToReturnOrder = `${order}/assignCourierToReturnOrder`;

export const assignCourierToReturnBundle = `${order}/assignCourierToReturnBundle`;

export const revokeReturnBundleCourierAssignment = `${order}/revokeReturnBundleCourierAssignment`;

export const cancelReturnBundle = `${order}/cancelReturnBundle`;

export const markMechanicSupportNeededFalseForBundle = `${order}/:orderId/markMechanicSupportNeededFalseForBundle/:bundleId`;

export const markReturnOrderIsActionNeededFalseForBundle = `${order}/markReturnOrderIsActionNeededFalseForBundle/:returnOrderId`;

export const reallocateBundleSupplier = `${order}/reallocateBundleSupplier`;

export const acceptPricedOrder = `${order}/acceptPricedOrder/:orderId`;

export const getParentOrdersProfile = `${order}/getParentOrdersProfile/:orderId`;

export const cancelParentOrder = `${order}/cancelParentOrder/:orderId`;

export const getParentOrders = `${order}/getParentOrders`;

export const deleteOrderItemParent = `${order}/deleteOrderItemParent`;

export const assignCourierToOrder = `${order}/assignCourierToOrder`;

export const revokeOrderCourierAssignment = `${order}/revokeOrderCourierAssignment/:orderId`;

export const reallocateOrderSupplier = `${order}/reallocateOrderSupplier`;

export const getOrderInvoiceInfoForCourier = `${order}/:orderId/getOrderInvoiceInfoForCourier`;

export const markOrderAsSupportNeeded = `${order}/:orderId/markOrderAsSupportNeeded`;

export const getSaleOrderInvoiceInfo = `${order}/:orderId/getSaleOrderInvoiceInfo/:warehouseId`;

export const getAllOrderItemNames = `${order}/getAllOrderItemNames`;

export const updateOrderIsSupportNeeded = `${order}/:orderId/updateOrderIsSupportNeeded`;

export const markVoiceOrderAsCreated = `${order}/:orderId/markVoiceOrderAsCreated`;

export const getAllFailedToReturnOrders = `${order}/getAllFailedToReturnOrders`;

export const getMechanicOrdersDetailsGivenMechanicId = `${order}/:mechanicId/getMechanicOrdersDetailsGivenMechanicId`;

export const getAllOrderItemsByOrderIdAndSupplierId = `${order}/:orderId/getAllOrderItemsByOrderIdAndSupplierId/:supplierId`;

export const summary = `${order}/summary`;

export const getSupplierTodayOrders = `${order}/getSupplierTodayOrders/:supplierId`;

export const getAllReturnOrdersForQuality = `${order}/getAllReturnOrdersForQuality`;

export const getAllOrderItemPricingHistory = `${order}/getAllOrderItemPricingHistory`;

export const getReturnOrders = `${order}/getReturnOrders`;

export const getOpFormOrderDetails = `${order}/:orderId/getOpFormOrderDetails`;

export const pickUpOrderItem = `${order}/:orderItemId/pickUpOrderItem`;

export const markOrderItemAsNotAvailable = `${order}/markOrderItemAsNotAvailable/:orderItemId`;

export const updateOrderItemAsSold = `${order}/updateOrderItemAsSold`;

export const fulfillOrder = `${order}/:orderId/fulfillOrder`;

export const editOpsNeedSupportReason = `${order}/editOpsNeedSupportReason`;

export const editMechanicNeedSupportReason = `${order}/editMechanicNeedSupportReason`;

export const editMechanicNeedSupportReasonForBundle = `${order}/editMechanicNeedSupportReasonForBundle`;

export const generateQrCodeForOrder = `${order}/generateQrCodeForOrder/:saleOrderId`;

export const getSaleOrdersInvoiceInfo = `${order}/getSaleOrderInvoiceInfo/:warehouseId`;

export const editInstaPartsDeliveryDate = `${order}/editPartsMartDeliveryDate`;

export const calculateInstaPartsActualDeliveryFullDate = `${order}/getPartsMartOrderDeliverySlots/:orderId`;

export const editMechanicNeedSupportOutput = `${order}/editMechanicNeedSupportOutput`;

export const editOpsNeedSupportOutput = `${order}/editOpsNeedSupportOutput`;

export const editVnStatus = `${order}/editVnStatus`;

export const editMechanicNeedSupportOutputForBundle = `${order}/editMechanicNeedSupportOutputForBundle`;

export const getConsignmentOrdersSummary = `${order}/getConsignmentOrdersSummary/:inventorySupplierId`;

export const getAllConsignmentOrdersForDispatching = `${order}/getAllConsignmentOrdersForDispatching/:inventorySupplierId`;

export const getConsignmentOrderInvoiceInfo = `${order}/getConsignmentOrderInvoiceInfo/:warehouseId`;
